import { useMemo, useState } from 'react';
import { MultiValue, SingleValue } from 'react-select';

import { SelectorOption, TenderOffer } from 'types';

type UseGetTenderOfferOptionsProps = {
  beneficiaryId: string;
  tenderOffers: TenderOffer[];
};

export const useGetTenderOfferOptions = ({
  beneficiaryId,
  tenderOffers,
}: UseGetTenderOfferOptionsProps) => {
  const [selectedTenderOffer, setSelectedTenderOffer] = useState<string>('');
  const [selectedTenderOfferOption, setSelectedTenderOfferOption] =
    useState<SelectorOption | null>(null);

  const handleChangeTenderOfferOption = (
    selectedOption: MultiValue<SelectorOption> | SingleValue<SelectorOption>
  ) => {
    if (!selectedOption) return;
    if (selectedOption instanceof Array) return;

    setSelectedTenderOfferOption(selectedOption);
    setSelectedTenderOffer(selectedOption.value);
  };

  const tenderOfferOptions = useMemo<SelectorOption[]>(() => {
    if (!beneficiaryId) return [];

    return tenderOffers
      .filter((offer) =>
        offer.participants?.some(
          (participant) => participant.id === beneficiaryId
        )
      )
      .map((offer) => ({
        value: offer._id,
        label: offer.name,
      }));
  }, [beneficiaryId, tenderOffers]);

  return {
    data: {
      selectedTenderOffer,
      selectedTenderOfferOption,
      tenderOfferOptions,
    },
    actions: {
      handleChangeTenderOfferOption,
    },
  };
};
